import Api from '../Api';

import { url } from './config';
import { BankAccount } from './types';

const api = new Api<BankAccount>(url);

export default api;
